import { postRequest } from '../../../shared/utils';

export async function getTbloptStateIdService({ state, screenGridId }) {
  const body = {
    columns: ['id'],
    screenGridId,
    schema: 'npi',
    table: 'tblopt_done_state',
    key: 'state',
    value: state,
  };

  const { data, errors } = await postRequest(`/api/records`, body);

  if (errors) {
    return { errors };
  }

  return data;
}
